import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../lib/api';

const BASE = '/mfg';

/* Shared fetch helper for mfg endpoints */
export function useMfgApi() {
  const { token } = useAuth();
  const headers = () => ({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });
  const base = process.env.REACT_APP_BACKEND_URL || '';

  const get = async (path, params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    const r = await fetch(`${base}/api/mfg${path}${qs}`, { headers: headers() });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw { status: r.status, detail: e.detail || e }; }
    return r.json();
  };
  const post = async (path, body) => {
    const r = await fetch(`${base}/api/mfg${path}`, { method: 'POST', headers: headers(), body: JSON.stringify({ ...body, idempotency_key: crypto.randomUUID() }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw { status: r.status, detail: e.detail || e }; }
    return r.json();
  };
  const patch = async (path, body) => {
    const r = await fetch(`${base}/api/mfg${path}`, { method: 'PATCH', headers: headers(), body: JSON.stringify(body) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw { status: r.status, detail: e.detail || e }; }
    return r.json();
  };
  const del = async (path) => {
    const r = await fetch(`${base}/api/mfg${path}`, { method: 'DELETE', headers: headers() });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw { status: r.status, detail: e.detail || e }; }
    return r.status === 204 ? null : r.json().catch(() => null);
  };
  const getPdf = (path, params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    window.open(`${base}/api/mfg${path}${qs}`, '_blank');
  };

  return { get, post, patch, del, getPdf, token };
}

export function errMsg(e) {
  const d = e?.detail;
  if (typeof d === 'string') return d;
  if (d?.message) return d.message;
  if (d?.msg) return d.msg;
  if (Array.isArray(d)) return d.map(x => x.msg || JSON.stringify(x)).join('; ');
  return 'Something went wrong';
}
